import { BOOLEAN_SELECT_LIST_ITEMS, Box, Grid, Stack, pn, useElementBreakpoints } from "@compass/core";
import { CustomFilters, Select } from "components";
import { ContributorFilter as ContributorFilterModel, ContributorFilterResource } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const ContributorFilter = (props: {
  filter: ContributorFilterModel;
  setFilter: (value: ContributorFilterModel) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<ContributorFilterResource>({});
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.contributors.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const filteredSubPartners = resource.subPartners?.filter((x) => x.partnerId === props.filter.partnerId) || [];
  const activeField = () => {
    const propertyName = pn<ContributorFilterModel>("active");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={BOOLEAN_SELECT_LIST_ITEMS.find((x) => x.id === props.filter.active)}
        options={BOOLEAN_SELECT_LIST_ITEMS}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.active = value?.id;
            })
          )
        }
      />
    );
  };

  const partnerField = () => {
    const propertyName = pn<ContributorFilterModel>("partnerId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={resource.partners?.find((x) => x.id === props.filter.partnerId)}
        options={resource.partners}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.partnerId = value?.id;
            })
          )
        }
      />
    );
  };

  const subPartnerField = () => {
    const propertyName = pn<ContributorFilterModel>("subPartnerId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={filteredSubPartners.find((x) => x.id === props.filter.subPartnerId)}
        options={filteredSubPartners}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) => {
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.subPartnerId = value?.id;
            })
          );
        }}
      />
    );
  };

  return (
    <Stack ref={breakpointsRef} spacing="lg">
      <CustomFilters
        filters={props.filter.customFilters}
        setFilters={(filters) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.customFilters = filters;
            })
          )
        }
        properties={resource.customFilterProperties}
      />

      <Box>
        <Grid container spacing="sm">
          <Grid item xs={smallFieldBreakpoints}>
            {activeField()}
          </Grid>

          <Grid item xs={smallFieldBreakpoints}>
            {partnerField()}
          </Grid>

          {filteredSubPartners.length > 0 && (
            <Grid item xs={smallFieldBreakpoints}>
              {subPartnerField()}
            </Grid>
          )}
        </Grid>
      </Box>
    </Stack>
  );
};
